import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';

const HeroSection = ({ darkMode }) => {
  return (
    <section className={`servicios-hero home-hero ${darkMode ? 'dark' : 'light'}`}>
      <div className="servicios-hero-content">
        <div className="servicios-hero-text">
          <h1 className="servicios-hero-title">
            Software de gestión e IA para pymes y ONG en Tenerife
          </h1>
          <p className="servicios-hero-subtitle servicios-hero-tagline">
            <strong>E-ASY</strong> acompaña a <strong>pymes</strong> y <strong>ONG</strong> cuando
            los datos están en sitios distintos, los informes no cuadran o el software
            no refleja cómo trabaja el equipo.
          </p>
          <p className="servicios-hero-subtitle">
            Del Excel al ERP en marcha: implantamos{' '}
            <Link to="/vulpin" className="vulpin-inline-link">
              Vulpin Suite
            </Link>
            ,{' '}
            <Link to="/servicios/business-central" className="vulpin-inline-link">
              Dynamics 365 Business Central
            </Link>
            {' '}y Odoo, o integramos el que ya está. En el mismo encargo
            cerramos la ciberseguridad de esos datos, conectamos la web al negocio
            y llevamos la IA de prototipo a{' '}
            <Link to="/servicios/ia-en-produccion" className="vulpin-inline-link">
              producción
            </Link>
            {' '}sobre{' '}
            <Link to="/servicios/azure" className="vulpin-inline-link">
              Azure
            </Link>
            .
          </p>
          <div className="servicios-hero-cta-wrapper">
            <Link to="/contacto" className="servicios-hero-cta">
              Hablar sobre mi gestión
            </Link>
          </div>
        </div>
        <div className="servicios-hero-video">
          <div className="servicios-hero-visual">
            <video
              autoPlay
              muted
              loop
              playsInline
              className="servicios-hero-video"
            >
              <source src="/videos/hero-home-v1.mp4" type="video/mp4" />
              <source src="/videos/hero-home-v1.webm" type="video/webm" />
              Tu navegador no soporta el elemento de video.
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 